import Page from 'actions/page';

export default Page.createReducer();
